import ls from "../localstorage";
import store from "../store";
const updateLocalData = (data) => {
    var userData = localStorage.fansData;
    userData = JSON.parse(userData);
    var uData = userData[0];
    var storeFansData;
    // here we store the local storage data
    storeFansData = {
        id: uData.id,
        username: data.username !== undefined ? data.username : uData.username,
        email: data.email !== undefined ? data.email : uData.email,
        firstname: data.firstname !== undefined ? data.firstname : '',
        lastname: data.lastname !== undefined ? data.lastname : '',
        club: data.club.length > 0 ? data.club : '',
        avatar: data.avatar !== undefined ? data.avatar : '',
        user_type: uData.user_type,
    };

    // here we store the data in vuex
    function storeVuex() {
        const userData = JSON.parse(localStorage.fansData);
        // store.state.fansData = userData;
        store.commit("setFansData", userData);
        store.state.user.fullname =
          userData[0].firstname + " " + userData[0].lastname;
        store.state.user.username = userData[0].username;
        store.state.user.email = userData[0].email;
        store.state.user.club = userData[0].club;
        store.state.user.id = userData[0].id;
        store.state.user.user_type = userData[0].user_type;
        store.state.user.avatar = userData[0].avatar;
    }
    if (ls.clearStorage("fansData")) {
        if(ls.setStorage("fansData", storeFansData)) {
            storeVuex();
            return true;
        }
    }
};

export default updateLocalData;